import React, { Component } from 'react';
import { Dimmer, Loader } from 'semantic-ui-react';

class Loading extends Component {
  constructor(props) {
    super(props);
    this.state = { timer: 0, timerDown: 60 };
  }
  countDown = () => {
    setInterval(() => {
      this.setState((prevState) => ({
        timerDown: prevState.timerDown - 1,
      }));
    }, 1000);
  }
  startCounting = () => {
    setInterval(() => {
      this.setState((prevState) => ({
        timer: prevState.timer + 1,
      }));
    }, 1000);
  }

  componentDidMount() {
    if (this.props.desc) {
      this.countDown();
    } else {
      this.startCounting();
    }

  }

  time = () => {
    const timer = this.state.timer;
    const minutes = Math.floor(timer / 60);
    const seconds = timer % 60;

    return minutes === 0
      ? `${seconds}s`
      : `${minutes}m ${seconds}s`;
  }



  render() {
    return (
      <div className={'mainLoader'}>
        <Dimmer active inverted>
          <Loader size='massive'> {this.props.desc ? `${this.state.timerDown}s` : this.time()} </Loader>
        </Dimmer>
      </div>
    );
  }
};


export default Loading;
